var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAzElectricity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.77 53.9l5.1 5.1H30V47.31v-1l5 5L45.07 40H22.23l20.56-24 3 2.6L30.92 36h22.73L37.77 53.9z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/AZ_Electricity.fc98f6bf.svg";
export { SvgAzElectricity as ReactComponent };